import { render, staticRenderFns } from "./createResource.vue?vue&type=template&id=afd2bb3a&"
import script from "./createResource.vue?vue&type=script&lang=js&"
export * from "./createResource.vue?vue&type=script&lang=js&"
import style0 from "./createResource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports